export const difficulty_map = {
    1: 'danger',
    2: 'warning',
    3: 'success',
    4: 'secondary'
}